export interface IUsers {
  users: any[];
}

export enum TransactionTypeEnum {
  DEPOSIT = 'DEPOSIT',
  WITHDRAWAL = 'WITHDRAWAL',
}

export interface ICreateNewsForm {
  title: string;
  body: string;
}

export interface IBalanceTransferParams {
  userId?: string;
  transactionId?: string;
  amount?: string;
  typeTransaction?: TransactionTypeEnum;
}

export interface IFee {
  totalFee: string;
  totalFeeRef: string;
}
